import { reducers } from '../generated';
import type { ConnectionManager } from '../core/ConnectionManager';
import type { ReducerClient } from '../core/ReducerClient';
import type { RegisterPlayerPayload, LoginPayload, Logger } from '../types';

export class AuthModule {
  constructor(
    private readonly connectionManager: ConnectionManager,
    private readonly reducerClient: ReducerClient,
    private readonly logger: Logger = () => undefined
  ) {}

  public async registerPlayer(payload: RegisterPlayerPayload): Promise<void> {
    await this.reducerClient.callAndConfirm({
      reducerName: 'register_player',
      paramsType: reducers.registerPlayer.paramsType,
      args: {
        playerId: payload.playerId,
        username: payload.username,
        password: payload.password,
        displayName: payload.displayName ?? null
      },
      onEvent: 'onRegisterPlayer',
      offEvent: 'removeOnRegisterPlayer',
      matchArgs: (args) => args.username === payload.username,
      timeoutMessage: 'Registration timed out',
      failureMessage: 'Registration failed'
    });
  }

  public async login(payload: LoginPayload): Promise<void> {
    await this.reducerClient.callAndConfirm({
      reducerName: 'login',
      paramsType: reducers.login.paramsType,
      args: {
        username: payload.username,
        password: payload.password
      },
      onEvent: 'onLogin',
      offEvent: 'removeOnLogin',
      matchArgs: (args) => args.username === payload.username,
      timeoutMessage: 'Login timed out',
      failureMessage: 'Login failed'
    });
    this.connectionManager.startSessionHeartbeat();
  }

  public async logout(): Promise<void> {
    this.connectionManager.stopSessionHeartbeat();
    await this.reducerClient.callFireAndForget(
      'logout',
      reducers.logout.paramsType,
      {}
    );
  }
}
